<template>
  <div class="distributor-box">
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="100" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters(false)}` + 'SKU：'" prop="ymsSkus">
              <Input type="textarea" :placeholder="$t('key1000324') + `${configCharacters(false)}` + $t('key1001090')" v-model.trim="pageParams.ymsSkus"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="`${configCharacters(false)}` + 'SPU：'" prop="ymsSpus">
              <Input type="textarea" :placeholder="$t('key1000324') + `${configCharacters(false)}` + $t('key1001089')" v-model.trim="pageParams.ymsSpus"></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1005790')" prop="skuInventory">
              <div class="flex align-items-center">
                <InputNumber :min="0" :max="999999" v-model="pageParams.skuInventoryStart" :formatter="value => `${parseInt(value)}`" style="width: 110px;"></InputNumber>
                <span class="ml12 mr12">-</span>
                <InputNumber :max="999999" v-model="pageParams.skuInventoryEnd" :formatter="value => `${parseInt(value)}`" style="width: 110px;"></InputNumber>
              </div>
            </FormItem>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box" v-if="getPermission('ymsDistributorInventory_batchExport') ||
        getPermission('ymsDistributorInventory_setDistributorInventoryPriority')">
      <Button type="primary" class="mr15" @click="changeExportBtn" v-if="getPermission('ymsDistributorInventory_batchExport')">{{ $t('key1005791') }}</Button>
      <Button type="primary" class="mr15" v-if="getPermission('ymsDistributorInventory_setDistributorInventoryPriority')"
        @click="$refs['inventoryPriorityConfig'].initInventoryPriorityConfigData()">{{ $t('key1005774') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        :update-show-children="true"
        ref="tableDom"
        row-key="treeId"
        :disabled-hover="true"
        :highlight-row="false"
        border
        max-height="550"
        :load-data="handleLoadData"
        :loading="tableLoading"
        @on-sort-change="sortChange"
        :columns="tableColumns"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <Page
      :transfer="true"
      v-if="!tableLoading"
      :total="total"
      class="distributor-page-box"
      @on-change="changePage"
      show-total
      :page-size="pageParams.pageSize"
      show-elevator
      :current="pageParams.pageNum"
      show-sizer
      @on-page-size-change="changePageSize"
      placement="top"
      :page-size-opts="pageArray">
    </Page>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1005791')"
      paramKeyColums="ymsDistributorInventoryExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--库存优先级配置弹窗-->
    <inventoryPriorityConfigModal ref="inventoryPriorityConfig"></inventoryPriorityConfigModal>
    <!--库存明细弹窗-->
    <myInventoryDetailsModal ref="myInventoryDetails"></myInventoryDetailsModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel, commonLocalStorage, getDistributorWarehouseData, isValueEmpty, pageJump, setConfigCharacters} from "@/utils/common";
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import inventoryPriorityConfigModal from "@/views/distributor/components/commodityManage/inventoryPriorityConfigModal.vue";
import myInventoryDetailsModal from "@/views/distributor/components/commodityManage/myInventoryDetailsModal.vue";

export default {
  name: 'myInventory',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        ymsSkus: '',
        ymsSpus: '',
        skuInventoryStart: null,
        skuInventoryEnd: null,
        upDown: null, // down 降序、up 升序
        orderBy: null, // availableNumber 可用库存、 intransitStockQuantity 在途库存
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'productInfo',
          minWidth: 240,
          align: 'left',
          tree: true,
          className: 'set_productInfo_box',
          render(h, params) {
            let parentLevel = params.row.parentLevel;
            if (parentLevel) {
              let ymsSpu = params.row.ymsSpu;
              if (params.row._productInfo) {
                let skuImgPath = params.row._productInfo.primaryImage;
                let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
                let imgPath = skuImgPath ? skuImgPath : spuImgPath;
                return h('div', {class: 'flex productInfo_content'}, [
                  v.tableImg(h, params, null, imgPath),
                  h('div', {
                    class: 'text-align-left pl10 mt1 mb2'
                  }, [
                    h('Alink', {
                      props: {
                        AlinkShow: false,
                        linkName: params.row.name,
                        textAlign: 'left',
                        AlinkClass: 'ellipsis_2'
                      }
                    }),
                    h('div', {class: 'flex align-items-start'}, [
                      h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                      h('p', {style: {flex: 1}}, ymsSpu),
                    ])
                  ])
                ]);
              }
            } else {
              let list = [];
              if (params.row._productInfo) {
                let ymsSku = params.row._productInfo.ymsSku;
                let productGoodsSpecificationList = params.row._productInfo.productGoodsSpecificationList || [];
                if (productGoodsSpecificationList.length > 0) {
                  list = productGoodsSpecificationList.map((item) => {
                    return item.value;
                  });
                }
                return h('div', {class: 'wid100P text-align-right'}, [
                  h('p', {class: 'mt2 mb2'}, ymsSku),
                  h('p', {class: 'mt2 mb2 color-green'}, list.join(' • '))
                ]);
              }
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005785'),
          key: 'recentSales',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let halfMonthlySales = params.row.halfMonthlySales;
            let weeklySales = params.row.weeklySales;
            return h('div', [
              h('p', {class: 'mt1 mb1'}, `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005783')}${weeklySales || 0}`),
              h('p', {class: 'mt1 mb1'}, `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005784')}${halfMonthlySales || 0}`)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005786'),
          key: 'availableNumber',
          minWidth: 130,
          align: 'left',
          sortable: 'custom',
          sortType: v.handleSortType('availableNumber'),
          render(h, params) {
            let availableNumber = params.row.availableNumber;
            return h('span', v.formatCurrency(availableNumber, 0));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005787'),
          key: 'intransitStockQuantity',
          minWidth: 130,
          align: 'left',
          sortable: 'custom',
          sortType: v.handleSortType('intransitStockQuantity'),
          render(h, params) {
            let intransitStockQuantity = params.row.intransitStockQuantity;
            return h('span', v.formatCurrency(intransitStockQuantity, 0));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004780'),
          key: 'warehouse',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            let ymsWarehouseName = '';
            let ymsWarehouseId = params.row.ymsWarehouseId;
            if (v.ymsWarehouseData.length > 0) {
              v.ymsWarehouseData.map((item) => {
                if (item.ymsWarehouseId === ymsWarehouseId) {
                  ymsWarehouseName = item.name;
                }
              });
            }
            return h('span', ymsWarehouseName);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005788'),
          key: 'averagePrice',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            let averagePrice = params.row.averagePrice;
            let price = amountHandel(averagePrice);
            let text = !isValueEmpty(price) ? (v.currencyState + ' ' + price) : '-';
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 120,
          align: 'left',
          render(h, params) {
            let parentLevel = params.row.parentLevel;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004665'),
                    show: !parentLevel && v.getPermission('ymsDistributorInventory_details'),
                    clickFn: () => {
                      v.$refs['myInventoryDetails'].initMyInventoryDetailsData(params.row);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000929'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'productName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380')},
            {paramKey: 'ymsSku', paramValue: `${setConfigCharacters(false)}SKU`},
            {paramKey: 'warehouseName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328')},
            {paramKey: 'availableNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000243')},
            {paramKey: 'specifications', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004657'), disabledDrag: true}
          ]
        }
      ],
      ymsWarehouseData: [],
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 处理默认排序的显示
    handleSortType(key) {
      let sortType = null;
      let values = commonLocalStorage.getItem('myInventorySort');
      if (values) {
        let obj = {
          down: 'desc',
          up: 'asc'
        };
        if (values.orderBy === key) {
          sortType = obj[values.upDown];
        }
      }
      return sortType;
    },
    // 初始化接口数据
    initFun() {
      (async () => {
        await getDistributorWarehouseData(this.userInfo.merchantId).then((data) => {
          this.ymsWarehouseData = data || [];
        });
        await this.handleSort();
        await this.search();
      })();
    },
    // 处理根据缓存的排序参数查询
    handleSort() {
      let obj = commonLocalStorage.getItem('myInventorySort');
      if (obj) {
        this.pageParams.upDown = obj.upDown;
        this.pageParams.orderBy = obj.orderBy;
      }
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.skuInventoryStart = null;
      v.pageParams.skuInventoryEnd = null;
      v.getList();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let keyList = ['ymsSkus', 'ymsSpus'];
      for (let key in params) {
        if (keyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      let {skuInventoryStart, skuInventoryEnd, ...obj} = v.pageParams;
      if (skuInventoryStart && skuInventoryEnd) {
        params.skuInventoryStart = skuInventoryStart;
        params.skuInventoryEnd = skuInventoryEnd;
      } else if (skuInventoryStart && !skuInventoryEnd) {
        params.skuInventoryStart = skuInventoryStart;
        params.skuInventoryEnd = 999999;
      } else if (!skuInventoryStart && skuInventoryEnd) {
        params.skuInventoryStart = 0;
        params.skuInventoryEnd = skuInventoryEnd;
      }
      let values = {
        upDown: params.upDown,
        orderBy: params.orderBy,
      };
      commonLocalStorage.setItem('myInventorySort', values);
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      if (!isValueEmpty(v.pageParams.skuInventoryStart) && !isValueEmpty(v.pageParams.skuInventoryEnd)) {
        if (v.pageParams.skuInventoryStart <= v.pageParams.skuInventoryEnd) {
          handleList();
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005789'));
          return false;
        }
      } else {
        handleList();
      }

      function handleList() {
        v.tableData = [];
        v.total = 0;
        v.optionBtnWidth = [];
        if (v.getPermission('ymsDistributorInventory_query')) {
          v.tableLoading = true;
          v.axios.post(api.post_ymsDistributorInventory_query, v.handleParameter()).then(response => {
            if (response.data.code === 0) {
              let data = response.data.datas;
              if (data) {
                let list = data.list || [];
                v.total = data.total;
                v.handleInventoryData(list);
              }
            } else {
              v.tableLoading = false;
            }
          });
        } else {
          v.gotoError();
        }
      }
    },
    // 处理列表数据
    handleInventoryData(data) {
      let v = this;
      let ymsProductGoodsIds = [];
      if (data.length > 0) {
        data.map((item) => {
          ymsProductGoodsIds.push(item.ymsProductGoodsId);
        });
      } else {
        v.tableLoading = false;
      }
      if (ymsProductGoodsIds.length > 0) {
        v.getProductInfoByIds(ymsProductGoodsIds, data).then((newData) => {
          if (newData && newData.length > 0) {
            newData.map((item) => {
              item.treeId = 'parentLevel_' + item.ymsInventoryId + '_' + item.ymsProductId + '_' + item.ymsProductGoodsId + '_' + item.ymsWarehouseId;
              item.parentLevel = true;
              item._loading = false;
              item._showChildren = false;
              item.children = [];
            });
            v.tableData = newData;
            v.updateTableDom('tableDom');
          }
        });
      } else {
        v.tableData = data;
      }
    },
    // 异步请求获取spu下所有的sku
    handleLoadData(item, callback) {
      let v = this;
      v.optionBtnWidth = [];
      let originalItem = JSON.parse(JSON.stringify(item));
      let ymsProductGoodsIds = [];
      if (originalItem.children.length <= 0) {
        let query = {
          ymsProductIds: [originalItem.ymsProductId],
          ymsWarehouseId: item.ymsWarehouseId
        };
        v.axios.post(api.post_ymsDistributorInventory_queryByYmsProductIds, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            data.map((ele) => {
              if (ele.ymsProductGoodsId) {
                ymsProductGoodsIds.push(ele.ymsProductGoodsId);
              }
            });
            if (ymsProductGoodsIds.length > 0) {
              v.getProductInfoByIds(ymsProductGoodsIds, data).then((newData) => {
                originalItem._loading = false;
                if (newData && newData.length > 0) {
                  newData.map((ele) => {
                    ele.parentLevel = false;
                    ele.treeId = 'childLevel_' + ele.ymsInventoryId + '_' + ele.ymsProductId + '_' + ele.ymsProductGoodsId + '_' + ele.ymsWarehouseId;
                  });
                  callback(newData);
                  v.$forceUpdate();
                  v.updateTableDom('tableDom', 1000, false);
                }
              });
            }
          }
        });
      } else {
        callback();
      }
    },
    // 导出库存
    changeExportBtn() {
      if (this.tableData.length <= 0) {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
        return false;
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          v.axios.post(api.post_ymsDistributorInventory_batchExport, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    exportFieldsModal,
    inventoryPriorityConfigModal,
    myInventoryDetailsModal
  }
};
</script>

<style lang="less" scoped>
/deep/ .table-box {
  .set_productInfo_box {
    .ivu-table-cell {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .productInfo_content {
        order: 1;
      }

      .ivu-table-cell-tree {
        order: 2;
      }
    }
  }
}
</style>

